import React, { useState } from "react";
import { generateFixedNumbersForTradeInPopup } from "../../utils";
import { useTranslation } from "react-i18next";
import SolarStarLineDuotone from "../../Icons/SolarStarLineDuotone";
import Tooltip from "../common-components/Tooltip";

const ConditionStarsField = ({ setFieldValue, errors }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [starItems] = useState(generateFixedNumbersForTradeInPopup(5));
  const { t } = useTranslation();

  return (
    <>
      <label className="flex items-center mb-4">
        {t("/vehicleDetails.Condition")}&nbsp;
        <span className="text-red-700 pr-2">*</span>
        <Tooltip
          text={t(
            "/vehicleDetails.Rate your vehicle from one (heavy signs of wear) to five (like new) stars. The choice of stars has no influence on the preliminary rating and is merely information for the car dealership.",
          )}
          spanClassName={
            "translate-x-[-5rem] max-sm:translate-x-[-5rem] max-sm:max-w-[16rem] max-w-[18rem]"
          }
        >
          <abbr>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 11.8333C8.18889 11.8333 8.34733 11.7693 8.47533 11.6413C8.60333 11.5133 8.66711 11.3551 8.66667 11.1667C8.66622 10.9782 8.60222 10.82 8.47467 10.692C8.34711 10.564 8.18889 10.5 8 10.5C7.81111 10.5 7.65289 10.564 7.52533 10.692C7.39778 10.82 7.33378 10.9782 7.33333 11.1667C7.33289 11.3551 7.39689 11.5136 7.52533 11.642C7.65378 11.7704 7.812 11.8342 8 11.8333ZM7.33333 9.16667H8.66667V5.16667H7.33333V9.16667ZM5.5 14.5L2 11V6L5.5 2.5H10.5L14 6V11L10.5 14.5H5.5ZM6.06667 13.1667H9.93333L12.6667 10.4333V6.56667L9.93333 3.83333H6.06667L3.33333 6.56667V10.4333L6.06667 13.1667Z"
                fill="#0F74C7"
              ></path>
            </svg>
          </abbr>
        </Tooltip>
      </label>
      <div className="flex items-center gap-3">
        {starItems.map((star) => (
          <SolarStarLineDuotone
            key={star}
            className={`text-[${errors?.condition ? "#FF0000" : "#555555"}] hover:fill-green-500 ${
              errors?.condition ? "text-red-700 :text-green-500" : ""
            } ${
              star <= (hover || rating) ? "fill-green-500 text-[#48bb78]" : ""
            }`}
            onClick={() => {
              setRating(star);
              setFieldValue("condition", star);
            }}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
          />
        ))}
      </div>
    </>
  );
};

export default ConditionStarsField;
